import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {CssBaseline} from "@mui/material";
import type {} from "@mui/material/themeCssVarsAugmentation";
import RenderRouter from "./router";
import {BrowserRouter} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import NProgress from "nprogress";
import {Suspense, useEffect} from "react";
import "nprogress/nprogress.css";
import TipBox from "@/widget/TipBox/TipBox";
import 'react-datepicker/dist/react-datepicker.css'
import {registerLocale} from 'react-datepicker'
import {zhCN} from 'date-fns/locale/zh-CN';

registerLocale('zhCN', zhCN)

NProgress.configure({
    showSpinner: false,
    minimum: 0.1,
    trickleSpeed: 200,
});

export default function ProgressBar() {
    useEffect(() => {
        let lastHref = window.location.href;
        const handleRouteChange = () => {
            NProgress.start();
            const timer = setTimeout(() => NProgress.done(), 100);
            return () => {
                clearTimeout(timer);
                NProgress.done();
            };
        };

        // 监听 href 变化
        const observer = new MutationObserver(() => {
            const currentHref = window.location.href;

            if (currentHref !== lastHref) {
                lastHref = currentHref;
                handleRouteChange();
            }
        });

        // 观察整个文档的变化
        observer.observe(document, {
            subtree: true,
            childList: true,
        });

        // 监听 popstate 事件（处理浏览器前进后退）
        window.addEventListener("popstate", handleRouteChange);

        // 初始加载时触发一次
        handleRouteChange();

        // 清理监听器
        return () => {
            observer.disconnect();
            window.removeEventListener("popstate", handleRouteChange);
        };
    }, []);

    return null;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <QueryClientProvider
            client={
                new QueryClient({
                    defaultOptions: {
                        queries: {retry: 0, refetchOnWindowFocus: false},
                    },
                })
            }
        >
            <Suspense>
                <TipBox>
                    <ProgressBar/>
                    <CssBaseline/>
                    <BrowserRouter
                        future={{
                            v7_startTransition: true,
                            v7_relativeSplatPath: true,
                        }}
                    >

                        <RenderRouter/>
                    </BrowserRouter>
                </TipBox>
            </Suspense>
        </QueryClientProvider>
    </React.StrictMode>,
);
